module.exports = __webpack_public_path__ + "static/media/Samsung a10.e47a75e9.jpg";